import { render } from "./documenti.vue?vue&type=template&id=f9184d84&ts=true"
import script from "./documenti.vue?vue&type=script&lang=ts"
export * from "./documenti.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\CarpeDiem\\AntiSmoking\\Backend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__